import React, { useContext } from 'react';
import styled from 'styled-components';
import BackArrow from '../../../assets/icons/arrow-back-red.svg';
import { draftStore } from '../../../store';
import { Row, Col } from '../../../components/layout';
import { setStep, startDraft } from '../../../actions/status';
import { setNumberOfRounds } from '../../../actions/options';
import { RadioInput, RadioMark } from '../../../components/input';
import { PrimaryButton, OutlineButton } from '../../../components/buttons';
import { useMediaQuery } from 'react-responsive';
import { mobileBreakpoint } from '../../../lib';

const roundOptions = [
    1,2,3,4,5,6,7
];

const RoundContainer = styled.div`
    position: relative;
    cursor: pointer;
    height: 60px;
    flex: 0 1 calc(14.28% - 20px);
    background-color: #161718;
    border-bottom: ${props => props.isSelected ? '3px solid #d6001c' : '3px solid transparent'};
    margin: 0 0 12px 20px;
    transition: border-bottom 0.25s;
    @media(max-width: 1080px){
        flex: 0 1 calc(25% - 20px);
    }
    @media(max-width: 900px){
        flex: 0 1 calc(100% - 10px);
    }
`

const Text = styled.div`
    padding: 21px 10px 0 45px;
    font-weight: ${props => props.checked ? 700 : 400};
`

const BackButton = styled(OutlineButton)`
    position: absolute;
`;

const StartButton = styled(PrimaryButton)`
    padding: 10px 38px;
`

const P = styled.p`
    font-weight: 700;
    margin-bottom: 35px;
    @media(max-width: 900px){
        margin: 20px 0;
    }
`

const BackIcon = styled.img.attrs(props => ({
    src: props.src
}))`
    position: relative;
    top: 5px;
    padding-right: 5px;
`;

function RoundSelect(){
    const { state, dispatch } = useContext(draftStore);
    const { options: { totalRounds, year }, roundPick: { data: roundPickRanges } } = state;
    const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    return (
        <>
            <Row margin={isMobile ? '20px 0 0 0' : '53px 0 0 0'} justifyContent="space-between">
                <Col><P>Select the number of rounds:</P></Col>
            </Row>
            <Row margin="0 0 0 -20px">
                {roundOptions.map((opt,id) => {
                    const isChecked = totalRounds === opt;
                    return (
                        <RoundContainer key={id} onClick={() => dispatch(setNumberOfRounds(opt))} isSelected={isChecked}>
                            <RadioInput type="radio" checked={isChecked} readOnly/>
                            <RadioMark checked={isChecked} />
                            <Text checked={isChecked}>{opt} Round<span style={{visibility: id === 0 ? 'hidden' : 'auto'}}>s</span></Text>
                        </RoundContainer>
                    );
                })}
            </Row>
            <Row margin={isMobile ? "10px 0 20px 0" : "40px 0"}>
                {!isMobile &&               
                <BackButton onClick={() => dispatch(setStep(state.status.step - 1))}><BackIcon src={BackArrow} />Back</BackButton>
                }
                <Col size="100%" justifyContent="center">
                    <StartButton onClick={() => dispatch(startDraft(year, roundPickRanges, totalRounds))}> Start Draft </StartButton>
                </Col>
            </Row>
            {isMobile && <Row justifyContent="center">
                <BackButton onClick={() => dispatch(setStep(state.status.step - 1))}> <BackIcon src={BackArrow} /> Back</BackButton>
            </Row>}
        </>
    )
}

export default RoundSelect;